function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "exit");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "exit",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  transform: "translate(1.000000, 1.000000)"
}, React.createElement("path", {
  d: "M0.47836286,0 L29.9336782,48",
  id: "Path-Copy-2",
  stroke: "#ECE5D9",
  strokeWidth: 2
}), React.createElement("path", {
  d: "M0.4783624,0 L29.9336778,48",
  id: "Path-Copy-3",
  stroke: "#ECE5D9",
  strokeWidth: 2,
  transform: "translate(15.206020, 24.000000) scale(-1, 1) translate(-15.206020, -24.000000) "
}), React.createElement("path", {
  d: "M-1,-1 L31,-1 L31,49 L-1,49 L-1,-1 Z M1,1 L1,47 L29,47 L29,1 L1,1 Z",
  id: "Rectangle-Copy-3",
  fill: "#ECE5D9",
  fillRule: "nonzero"
})));

var SvgExit = function SvgExit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 50",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/exit.cf2d700d.svg";
export { ForwardRef as ReactComponent };